export class Slug {
    constructor(id, restaurantId, menusSlugs) {
        this.id = id || '';
        this.restaurantId = restaurantId || '';
        this.menusSlugs = menusSlugs || new Map();
    }
}
